import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { config } from 'src/config';
import { environment } from 'src/environments/environment';

const API_BASE_URL =
  config.careerreconApiUrl[
    environment.env as keyof typeof config.careerreconApiUrl
  ];

@Injectable({
  providedIn: 'root',
})
export class CareerReconService {
  constructor(private httpClient: HttpClient) {}

  getCareer(params: any) {
    return this.httpClient.get(`${API_BASE_URL}/careers/`, { params }).pipe(
      map((response: any) => {
        return response.data.rows;
      }),
    );
  }

  getLookup(params: any) {
    return this.httpClient.get(`${API_BASE_URL}/lookups/`, { params }).pipe(
      map((response: any) => {
        return response.data.rows;
      }),
    );
  }

  getThirdPartyLookup(params: any) {
    return this.httpClient.get(`${API_BASE_URL}/thirdparties`, { params }).pipe(
      map((response: any) => {
        return response.data.data;
      }),
    );
  }

  getFilterLog(id: string) {
    return this.httpClient.get(`${API_BASE_URL}/filter-logs/${id}`).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }

  createCareerUser(user: any) {
    return this.httpClient.post(`${API_BASE_URL}/filter-logs`, user).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }

  updateCareerUser(filerLogId: any, user: any, params: { paramType: string }) {
    return this.httpClient
      .put(`${API_BASE_URL}/filter-logs/${filerLogId}`, user, { params })
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  getCompany() {
    return this.httpClient.get(`${API_BASE_URL}/companies/default`).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }

  updateResume(uuid:string, file: any) {
    return this.httpClient.post(`${API_BASE_URL}/students/${uuid}/upload/resume`, file).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }
}
